import type * as FormModelType from "@/components/features/dialog/re-onboarding-request/model/type";

export const reOnboardingRequestInputModelFactory = (
	hotelID: string,
	email?: string | null,
): FormModelType.ReOnboardingRequestFormModel["InputModel"] =>
	({
		hotelID,
		updatedEmail: email || "",
		message: "",
	}) satisfies FormModelType.ReOnboardingRequestFormModel["InputModel"];
